import React from "react";

const Elopement = ({ size = 50, color }: any) => {
  return (
    <svg
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 128 128"
      width={size}
      height={size}
    >
      <g id="Layer_1" className="st0">
        <g id="xI9lC2_1_" className="st1">
          <g>
            <path
              fill="none"
              d="M54.75,0c2.33,0,4.67,0,7,0c0.69,0.09,1.38,0.2,2.08,0.28c13.05,1.55,24.11,7.09,32.95,16.83
                        c7.9,8.7,12.39,18.97,13.24,30.71c0.3,4.19,0.15,8.41,0.26,12.61c0.02,0.72,0.17,1.49,0.49,2.13c2.94,5.97,5.96,11.9,8.9,17.88
                        c1.71,3.48-0.54,7.02-4.42,7.05c-2.67,0.02-5.33,0-8,0c-0.65,0-1.29,0-1.98,0c0,4.48,0,8.77,0,13.06
                        c-0.01,7.16-4.75,11.93-11.88,11.94c-3.12,0-6.25,0-9.37,0c-0.4,0-0.79,0-1.24,0c0,3.81,0,7.43,0,11.05
                        c0,3.01-1.42,4.45-4.43,4.45c-16.21,0-32.42,0-48.62,0c-3.02,0-4.45-1.42-4.45-4.42c0-10.62-0.01-21.25,0.02-31.87
                        c0-0.91-0.26-1.52-0.91-2.17C10.33,75.46,5.05,58.62,9.08,39.16C13.13,19.6,30.09,3.81,49.71,0.74C51.39,0.48,53.07,0.25,54.75,0
                        z M37.04,23.73c-1.85,0.09-2.98,0.6-3.66,1.76c-2.59,4.42-5.17,8.84-7.66,13.31c-1.01,1.82-0.39,3.75,1.36,4.89
                        c0.77,0.5,1.56,0.96,2.38,1.37c0.63,0.31,0.73,0.71,0.68,1.4c-0.11,1.53-0.24,3.1-0.03,4.61c0.17,1.21-0.26,1.73-1.22,2.19
                        c-4.27,2.06-4.41,4.28-2.17,7.85c2.17,3.45,4.1,7.05,6.15,10.58c1.59,2.75,3.45,3.23,6.24,1.64c0.22-0.12,0.46-0.21,0.65-0.37
                        c1.1-0.95,2.12-1.01,3.23,0.04c0.53,0.5,1.21,0.95,1.91,1.16c2.23,0.68,2.85,2.09,2.66,4.36c-0.23,2.74,1.43,4.23,4.19,4.23
                        c4.58,0.01,9.17,0,13.75,0c3.08,0,4.62-1.43,4.46-4.5c-0.1-1.96,0.23-3.38,2.33-3.91c0.27-0.07,0.56-0.22,0.76-0.42
                        c2-1.95,3.91-1.84,6.16-0.22c1.68,1.21,3.82,0.58,4.89-1.2c2.62-4.39,5.18-8.83,7.67-13.3c0.99-1.77,0.4-3.67-1.26-4.83
                        c-0.41-0.29-0.83-0.58-1.29-0.76c-1.48-0.59-2.28-1.49-1.77-3.2c0.15-0.5,0.16-1.1,0.03-1.61c-0.62-2.53,0.36-3.97,2.71-5.05
                        c2.12-0.97,2.61-3.18,1.47-5.22c-2.44-4.31-4.91-8.6-7.43-12.86c-1.16-1.95-3.35-2.66-5.15-1.3c-2.22,1.66-3.79,1.11-6-0.13
                        c-2.32-1.29-3.45-2.53-3.14-5.28c0.24-2.04-1.53-3.68-3.58-3.7c-5.08-0.05-10.17-0.05-15.25,0c-2,0.02-3.5,1.62-3.59,3.62
                        c-0.04,0.87-0.07,1.75,0.01,2.62c0.07,0.81-0.29,1.15-0.97,1.49c-1.34,0.67-2.7,1.34-3.88,2.25c-0.95,0.73-1.6,0.61-2.52,0.05
                        C39.03,24.62,37.81,24.11,37.04,23.73z"
            />
            <path
              fill="none"
              className="st2"
              d="M37.04,23.73c0.77,0.39,1.99,0.9,3.11,1.58c0.91,0.56,1.57,0.67,2.52-0.05c1.18-0.9,2.54-1.58,3.88-2.25
                        c0.68-0.34,1.04-0.69,0.97-1.49c-0.08-0.87-0.04-1.75-0.01-2.62c0.08-2,1.59-3.6,3.59-3.62c5.08-0.05,10.17-0.05,15.25,0
                        c2.05,0.02,3.82,1.65,3.58,3.7c-0.32,2.74,0.82,3.98,3.14,5.28c2.22,1.24,3.79,1.79,6,0.13c1.8-1.35,4-0.65,5.15,1.3
                        c2.52,4.26,5,8.55,7.43,12.86c1.15,2.03,0.66,4.25-1.47,5.22c-2.35,1.07-3.33,2.52-2.71,5.05c0.12,0.51,0.12,1.11-0.03,1.61
                        c-0.51,1.71,0.29,2.61,1.77,3.2c0.46,0.18,0.88,0.47,1.29,0.76c1.66,1.16,2.25,3.06,1.26,4.83c-2.49,4.47-5.05,8.91-7.67,13.3
                        c-1.07,1.78-3.21,2.41-4.89,1.2c-2.25-1.62-4.16-1.73-6.16,0.22c-0.2,0.2-0.49,0.35-0.76,0.42c-2.09,0.54-2.43,1.95-2.33,3.91
                        c0.16,3.08-1.38,4.5-4.46,4.5c-4.58,0-9.17,0.01-13.75,0c-2.76,0-4.42-1.5-4.19-4.23c0.19-2.28-0.43-3.68-2.66-4.36
                        c-0.69-0.21-1.38-0.66-1.91-1.16c-1.11-1.05-2.14-0.99-3.23-0.04c-0.19,0.16-0.43,0.25-0.65,0.37c-2.79,1.6-4.65,1.11-6.24-1.64
                        c-2.04-3.53-3.98-7.13-6.15-10.58c-2.24-3.56-2.1-5.79,2.17-7.85c0.96-0.46,1.39-0.98,1.22-2.19c-0.21-1.51-0.08-3.08,0.03-4.61
                        c0.05-0.68-0.06-1.08-0.68-1.4c-0.82-0.41-1.61-0.88-2.38-1.37c-1.75-1.14-2.38-3.08-1.36-4.89c2.49-4.47,5.08-8.89,7.66-13.31
                        C34.05,24.33,35.18,23.81,37.04,23.73z M34.14,39.11c0.47,0.28,0.85,0.51,1.24,0.73c2.52,1.46,2.8,2.49,2.51,5.34
                        c-0.26,2.58-0.21,5.23,0.04,7.81c0.25,2.5-0.13,3.74-2.28,5.01c-0.51,0.3-0.99,0.63-1.5,0.95c1.3,2.24,2.5,4.31,3.72,6.41
                        c0.76-0.43,1.37-0.79,1.99-1.12c1.6-0.87,3.14-0.78,4.52,0.43c2.38,2.09,5.04,3.64,8.05,4.66c1.67,0.57,2.5,1.87,2.55,3.63
                        c0.02,0.74,0,1.47,0,2.21c2.58,0,5.01,0,7.51,0c0-0.84-0.02-1.58,0-2.33c0.05-1.67,0.86-2.91,2.42-3.45
                        c3.08-1.06,5.81-2.64,8.26-4.79c1.29-1.13,2.79-1.2,4.31-0.41c0.69,0.36,1.37,0.76,2.12,1.18c1.27-2.2,2.48-4.31,3.73-6.46
                        c-0.76-0.45-1.41-0.81-2.05-1.21c-1.41-0.88-2.13-2.17-1.81-3.8c0.63-3.28,0.61-6.52,0-9.8c-0.31-1.64,0.43-2.92,1.86-3.78
                        c0.64-0.39,1.28-0.76,2.01-1.18c-1.25-2.17-2.47-4.28-3.73-6.46c-0.75,0.42-1.39,0.79-2.05,1.14c-1.56,0.82-3.08,0.76-4.42-0.41
                        c-2.41-2.12-5.11-3.69-8.15-4.73c-1.61-0.55-2.45-1.81-2.49-3.54c-0.02-0.77,0-1.54,0-2.31c-2.59,0-4.99,0-7.5,0
                        c0,0.76,0.01,1.46,0,2.16c-0.04,1.82-0.88,3.14-2.6,3.72c-2.97,1-5.59,2.54-7.94,4.59c-1.48,1.29-2.99,1.37-4.73,0.4
                        c-0.6-0.33-1.19-0.69-1.83-1.06C36.59,34.86,35.38,36.95,34.14,39.11z"
            />
            <path
              fill="none"
              d="M34.14,39.11c1.25-2.16,2.45-4.25,3.74-6.48c0.64,0.37,1.23,0.73,1.83,1.06c1.75,0.97,3.25,0.89,4.73-0.4
                        c2.36-2.05,4.98-3.59,7.94-4.59c1.73-0.58,2.56-1.91,2.6-3.72c0.01-0.7,0-1.4,0-2.16c2.51,0,4.91,0,7.5,0
                        c0,0.76-0.02,1.53,0,2.31c0.04,1.73,0.88,2.99,2.49,3.54c3.04,1.03,5.74,2.61,8.15,4.73c1.33,1.17,2.86,1.23,4.42,0.41
                        c0.66-0.35,1.3-0.72,2.05-1.14c1.26,2.18,2.47,4.29,3.73,6.46c-0.72,0.43-1.37,0.8-2.01,1.18c-1.42,0.86-2.17,2.14-1.86,3.78
                        c0.62,3.28,0.63,6.52,0,9.8c-0.31,1.64,0.4,2.93,1.81,3.8c0.63,0.39,1.28,0.76,2.05,1.21c-1.24,2.16-2.46,4.26-3.73,6.46
                        c-0.75-0.42-1.42-0.82-2.12-1.18c-1.52-0.78-3.02-0.72-4.31,0.41c-2.44,2.15-5.18,3.73-8.26,4.79c-1.56,0.54-2.37,1.78-2.42,3.45
                        c-0.02,0.75,0,1.49,0,2.33c-2.5,0-4.93,0-7.51,0c0-0.74,0.02-1.47,0-2.21c-0.06-1.76-0.88-3.06-2.55-3.63
                        c-3-1.02-5.67-2.57-8.05-4.66c-1.37-1.21-2.92-1.3-4.52-0.43c-0.62,0.34-1.23,0.69-1.99,1.12c-1.22-2.1-2.42-4.17-3.72-6.41
                        c0.5-0.32,0.99-0.65,1.5-0.95c2.15-1.27,2.52-2.51,2.28-5.01c-0.26-2.58-0.31-5.23-0.04-7.81c0.29-2.85,0.01-3.88-2.51-5.34
                        C34.99,39.62,34.6,39.38,34.14,39.11z M44.99,48.99c0,7.57,6.17,13.75,13.73,13.75c7.55,0.01,13.76-6.19,13.76-13.74
                        c0-7.56-6.19-13.75-13.75-13.75C51.17,35.25,45,41.43,44.99,48.99z"
            />
            <path
              fill="none"
              className="st2"
              d="M44.99,48.99c0-7.57,6.18-13.74,13.74-13.74c7.56,0,13.75,6.2,13.75,13.75c0,7.55-6.21,13.75-13.76,13.74
                        C51.16,62.74,44.99,56.56,44.99,48.99z M52.49,48.91c-0.03,3.48,2.73,6.31,6.18,6.33c3.45,0.03,6.29-2.78,6.31-6.22
                        c0.01-3.4-2.74-6.21-6.13-6.27C55.38,42.7,52.53,45.46,52.49,48.91z"
            />
            <path
              fill="none"
              d="M52.49,48.91c0.03-3.45,2.89-6.21,6.36-6.16c3.39,0.05,6.15,2.87,6.13,6.27c-0.01,3.45-2.85,6.25-6.31,6.22
                        C55.22,55.22,52.46,52.39,52.49,48.91z"
            />
          </g>
        </g>
      </g>
      <g id="Layer_2">
        <g id="mNfa8v_1_">
          <g>
            <path
              fill={color}
              d="M24.32,128.06c0-14.24,0-28.47,0-42.77c32.2,0,64.25,0,96.45,0c0,0.55,0,1.03,0,1.52c0,13.21,0,26.43,0,39.64
                        c0,0.54,0.04,1.07,0.06,1.61c-2.49,0-4.97,0-7.46,0c-0.02-0.5-0.06-0.99-0.06-1.49c0-10.78,0-21.55,0-32.33c0-0.48,0-0.97,0-1.45
                        c-3.16,0-6.14,0-9.2,0c0.07,0.32,0.1,0.53,0.15,0.72c1.07,3.72,0.02,6.87-2.93,9.21c-1.63,1.29-3.52,2.39-5.47,3.09
                        c-2.66,0.96-5.48,1.47-8.32,2.19c0,2.65,0,5.47,0,8.4c4.85,0,9.6,0,14.39,0c0,3.95,0,7.8,0,11.65c-2.49,0-4.97,0-7.46,0
                        c0-1.39,0-2.77,0-4.15c-7.27,0-14.41,0-21.64,0c0,1.43,0,2.79,0,4.15c-2.49,0-4.97,0-7.46,0c0-3.88,0-7.75,0-11.75
                        c4.96,0,9.74,0,14.52,0c0-2.92,0-5.72,0-8.51c-1.35-0.22-2.62-0.38-3.87-0.64c-3.68-0.77-7.2-1.95-10.1-4.48
                        c-2.53-2.2-3.67-4.95-3.02-8.32c0.1-0.52,0.25-1.03,0.38-1.57c-10.52,0-20.97,0-31.49,0c0,11.83,0,23.55,0,35.27
                        C29.29,128.06,26.8,128.06,24.32,128.06z"
            />
            <path
              fill="none"
              className="st2"
              d="M31.78,128.06c0-11.72,0-23.44,0-35.27c10.52,0,20.97,0,31.49,0c-0.13,0.54-0.28,1.05-0.38,1.57
                        c-0.65,3.37,0.49,6.12,3.02,8.32c2.9,2.52,6.41,3.71,10.1,4.48c1.25,0.26,2.52,0.42,3.87,0.64c0,2.79,0,5.59,0,8.51
                        c-4.78,0-9.57,0-14.52,0c0,4,0,7.87,0,11.75C54.16,128.06,42.97,128.06,31.78,128.06z"
            />
            <path
              fill="none"
              className="st2"
              d="M101.92,128.06c0-3.85,0-7.69,0-11.65c-4.79,0-9.54,0-14.39,0c0-2.93,0-5.76,0-8.4
                        c2.84-0.72,5.66-1.23,8.32-2.19c1.95-0.7,3.84-1.8,5.47-3.09c2.95-2.34,4-5.49,2.93-9.21c-0.06-0.2-0.08-0.4-0.15-0.72
                        c3.05,0,6.04,0,9.2,0c0,0.48,0,0.96,0,1.45c0,10.78,0,21.55,0,32.33c0,0.5,0.04,0.99,0.06,1.49
                        C109.55,128.06,105.74,128.06,101.92,128.06z"
            />
            <path
              fill="none"
              className="st2"
              d="M72.82,128.06c0-1.36,0-2.72,0-4.15c7.23,0,14.37,0,21.64,0c0,1.38,0,2.77,0,4.15
                        C87.25,128.06,80.03,128.06,72.82,128.06z"
            />
            <path
              fill={color}
              d="M39.52,77.71c-11.17-8.54-21.14-17.75-27.51-30.2c-5.24-10.23-5.64-20.58,0.05-30.78C18.46,5.27,31.72-1.12,44.19,1.09
                        c13.77,2.43,23.91,12.49,26.2,25.92c1.37,8.04-0.7,15.35-4.53,22.31c-4.25,7.71-10.01,14.21-16.5,20.07
                        C46.2,72.24,42.86,74.9,39.52,77.71z M35.16,28.06c0.05-0.2,0.07-0.28,0.09-0.36c0.49-2.5,2.38-4.03,4.6-3.75
                        c2.24,0.29,3.86,2.18,3.74,4.37c-0.13,2.37-1.92,3.97-4.5,4c-1.1,0.01-2.21,0-3.28,0c0,3.21,0,6.25,0,9.27c2.49,0,4.87,0,7.26,0
                        c0.04-0.26,0.11-0.42,0.08-0.58c-0.24-1.34,0.33-1.98,1.57-2.57c4.49-2.15,6.88-6.96,6.21-12.07c-0.6-4.6-4.31-8.55-9.04-9.63
                        c-4.71-1.08-9.75,1.04-12.35,5.21c-1.16,1.85-1.81,3.85-1.73,6.11C30.31,28.06,32.7,28.06,35.16,28.06z M35.77,47.52
                        c0,2.51,0,4.89,0,7.3c2.48,0,4.89,0,7.31,0c0-2.48,0-4.86,0-7.3C40.62,47.52,38.24,47.52,35.77,47.52z"
            />
            <path
              fill={color}
              d="M63.2,77.76c-0.71-2.52-0.7-5-0.08-7.42c2.3-8.96,7.73-15.02,16.85-17.21c5.7-1.37,10.96,0.16,15.54,3.71
                        c5.69,4.42,9.06,10.16,9.13,17.53c0.03,3.39-0.04,3.39-3.35,3.39c-12.18,0-24.37,0-36.55,0C64.24,77.76,63.75,77.76,63.2,77.76z"
            />
            <path
              fill="none"
              className="st2"
              d="M35.16,28.06c-2.46,0-4.85,0-7.35,0c-0.08-2.27,0.57-4.26,1.73-6.11c2.6-4.16,7.64-6.28,12.35-5.21
                        c4.73,1.08,8.44,5.03,9.04,9.63c0.67,5.11-1.72,9.93-6.21,12.07c-1.25,0.6-1.82,1.24-1.57,2.57c0.03,0.15-0.04,0.32-0.08,0.58
                        c-2.39,0-4.77,0-7.26,0c0-3.02,0-6.06,0-9.27c1.08,0,2.18,0.01,3.28,0c2.58-0.03,4.37-1.63,4.5-4c0.12-2.18-1.51-4.08-3.74-4.37
                        c-2.22-0.29-4.1,1.25-4.6,3.75C35.23,27.78,35.2,27.86,35.16,28.06z"
            />
            <path
              fill="none"
              className="st2"
              d="M35.77,47.52c2.47,0,4.85,0,7.31,0c0,2.44,0,4.82,0,7.3c-2.42,0-4.83,0-7.31,0
                        C35.77,52.41,35.77,50.03,35.77,47.52z"
            />
          </g>
        </g>
      </g>
    </svg>
  );
};

export default Elopement;
